import { ref, Ref } from '@vue/composition-api';

const title = ref('');

export function useTitle() : Ref<string> {
  return title;
}
